export default "__VITE_ASSET__Blz7OucG__"